<template>

    <h2 class="section-title" v-if="ready && isSubtitle" v-html="subtitleText"></h2>

    <div class="col-2 field-group" v-if="ready && !isSubtitle"
         :class=" (isLabelOnly ? ' label-only ' : ' has-fields ')  + (group[0].key ?? ' no-group-removed-for-now ') ">

        <input-label :text="labelText"></input-label>

        <div :class="'col-' + remainingFields.length + ' input-container ' + groupFieldTypeClasses "
             v-if="! isLabelOnly ">
            <component
                v-for="field in remainingFields"
                :is="getComponentFromType(field)"
                :field="field"
                ref="allFields"
                :data="dataProfile"
                :datastore="dataStore"
                @update="updateProfile"
                @clearErrors="clearErrors"
                :class=" 'field-group-type_' + field.type "
            />


        </div>
        <span class="error" v-if="gotError" v-html="error"></span>
    </div>


</template>

<script>
export default {
    name : "FieldsGroup",
}
</script>

<script setup>

import { computed, ref, watch, onMounted } from "vue";
import { useStore }                        from "vuex";
import { uniq, flatten }                   from "lodash-es";


import InputLabel                                   from '../../components/form/InputLabel.vue';
import InputText                                    from '../../components/form/InputText.vue';
import InputRadios                                  from '../../components/form/InputRadios.vue';
import InputDropdown                                from '../../components/form/InputDropdown.vue';
import InputImageList                               from '../../components/form/InputImageList.vue';
import InputThemesList                              from '../../components/form/InputThemesList.vue';
import InputUpload                                  from '../../components/form/InputUpload.vue';
import PreviewAvatar                                from './PreviewAvatar.vue';
import PreviewAvatarProfs                           from './PreviewAvatarProfs.vue';
import InputCheckboxes                              from '../../components/form/InputCheckboxes.vue';
import { scrollToFirstError, scrollToTopOfProfile } from '../composables/UseCopydeck';
import BroadcastUserInfo                            from '../../BroadcastUserInfo';

let props = defineProps( [ "group", "data", "key1" ] );
let store = useStore();

let ready     = ref( false );
let allFields = ref( [] );

let error    = ref( "" );
let gotError = computed( () => error.value.length > 0 );

let dataProfile = computed( () => Object.assign(store.state.user ?? {} , store.state.user.profile ?? {} ));
let dataStore   = computed( () => store.state.datastore ?? {} );

let labelText = computed( () =>
{
    let label = props.group.find( f => f.type === 'label' );

    if ( label )
    {
        return label.title;
    }

    return props.group.length > 0 ? props.group[ 0 ].title : "";
} );


let subtitleText = computed( () =>
                          {
                              let subtitle = props.group.find( f => f.type === 'subtitle' );

                              if ( subtitle )
                              {
                                  return subtitle.title;
                              }

                              return props.group.length > 0 ? props.group[ 0 ].title : "";
                          } );

const remainingFields = computed( () => props.group.filter( ( field, index ) => !(index === 0 && field.type === 'label') ) ); //if first field is a label we remove it

const hasGroup = computed ( () => props.group.length > 0);
const firstGroupOptions = computed ( () => hasGroup.value && Array.isArray(props.group[ 0 ].options) ? props.group[ 0 ].options : []);
const textSize = computed ( () => firstGroupOptions.value.filter ( o => o.type === 'text-size'));
const isLabelSmallText = computed ( () => hasGroup.value && props.group[ 0 ].type === 'label' && (textSize.value.length > 0 && textSize.value[0].text_size === 'small'))
const isLabelOnly = computed( () => props.group.length === 1 && props.group[ 0 ].type === 'label' && !isLabelSmallText.value);
const isSubtitle = computed( () => hasGroup.value && props.group[ 0 ].type === 'subtitle');
const bui = new BroadcastUserInfo();


function getComponentFromType ( field )
{
    let standards =
            {
                "radios"      : InputRadios,
                "checkboxes"  : InputCheckboxes,
                "dropdown"    : InputDropdown,
                "image_list"  : InputImageList,
                "themes_list" : InputThemesList,
                "upload"      : InputUpload,
            }

    let customs =
            {
                "preview-avatar"      : PreviewAvatar,
                "preview-avatar-prof" : PreviewAvatarProfs,
            }

    if ( standards[ field.type ] )
    {
        return standards[ field.type ];
    }
    else if ( field.type === "custom" )
    {
        //if this list become long, we should think to switch to loaded component
        let customType = (field.custom ?? []).find( c => c.key === "type" )

        if ( customs[ customType.value ] )
            return customs[ customType.value ];

    }


    return InputText;
}

function getFieldName ()
{

}

function addErrors ( errors )
{

    let fields = allFields.value
        .filter( f => f.hasField( Object.keys( errors ) ) )
        .map( f => f.getKey() );


    if ( fields.length > 0 )
    {
        let arrErrors = fields.reduce( ( a, r ) => [ ...a, ...errors[ r ] ], [] );

        error.value = arrErrors.join( '<br>' );

        // give the errors time to be injected
        setTimeout( scrollToFirstError, 500 );
    }
}

function clearErrors ()
{
    error.value = "";
}


async function updateProfile ( payload )
{
    clearErrors();
    let response  = await store.dispatch( "updateUserProfile", payload );

    if (!response.success)
    {
        addErrors(response.errors);
    }
    else
    {
        if (payload.key === "name")
        {
            bui.broadcastName(payload.value);
            store.commit("name", payload.value);
        }
    }
}

watch( () => props.group, ( newVal, oldVal ) => onChanged() )

async function onChanged ()
{
    // let options = props.group.filter ( group => Array.isArray(group.options))
    // let test = options.map( o => o.options.filter( opt => opt.type === "preload-datas")).flat();
    // let testA = Array.isArray(test) ? test.flat() : [];
    //
    // let test2 = options.map( o => o.options[0]);
    // let test3 = options.map( o => o.options).map( opt => opt.type);
    // let preload = options.map( o => o.options.filter( opt => opt.type === "preload-datas")).map( opt => ({key: opt.key_preload, url: opt.preload}));
    ready.value = false;

    let toPreload = props.group
        .filter( group => Array.isArray( group.options ) )
        .map( o => o.options.filter( opt => opt.type === "preload-datas" ) )
        //.flat()

    toPreload  = flatten(toPreload)
        .map( obj => ({ url : obj.preload, key : obj.key_preload }) );


    await store.dispatch( "loadData", toPreload );

    ready.value = true;


}


const groupFieldTypeClasses = computed( () =>
{

    {

        let types = [];

        if ( remainingFields.value.length > 0 )
        {

            remainingFields.value.forEach( f => types.push( f.type ) );
        }


        if ( types.length > 0 )
        {
            types = uniq( types );
        }

        types = types.map( t => 'contains_' + t );


        return types.join( ' ' );
    }
} )

function onProfileChanged (event)
{

    let key = Object.keys(event.data)[0];
    //if (props.group.length > 0 && props.group[0].key === "key")
    if (props.group.length > 0)
    {
        if (props.group[0].key === key)
        {
            clearErrors();

            if (key === "name")
            {
                store.commit("name", event.data.name);
            }
            else if (key === "email")
            {
                store.commit("email", event.data.email);
            }
        }
    }
}

async function mounted ()
{

    await onChanged();
    bui.addListener(onProfileChanged)

    //compileGroupFieldTypeClasses(); <-- we cannot call a computed

}

onMounted( mounted )

defineExpose( { getFieldName, addErrors } );

</script>

<style scoped lang="scss">

//@for $i from 1 through 10
//{
//    .col-#{$i}
//    {
//        column-count: #{$i};
//    }
//}

</style>
